"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.areComparable = areComparable;
exports.isReleaseBuild = isReleaseBuild;
exports.isDevBuild = isDevBuild;
exports.comparableReleaseTagToNumber = comparableReleaseTagToNumber;
exports.releaseTagToNumber = releaseTagToNumber;
exports.isReleaseGreaterThanOrEqualToVersion = isReleaseGreaterThanOrEqualToVersion;
const ciSomethingPattern = /^ci-([1-9][0-9]+)$/;
const rSomethingPattern = /^R([1-9]+)\.([0-9]+)\.([0-9]+)(-rc[1-9][0-9]*)?$/;
function areComparable(releaseName1, releaseName2) {
    if (releaseName1.startsWith(releaseName2[0])) {
        // The releases need to be in the same 'series'
        if (isUnderstandableReleaseTag(releaseName1) && isUnderstandableReleaseTag(releaseName2)) {
            return true;
        }
    }
    return false;
}
function isUnderstandableReleaseTag(releaseTag) {
    return isReleaseBuild(releaseTag) || isDevBuild(releaseTag);
}
function isReleaseBuild(releaseTag) {
    return rSomethingPattern.test(releaseTag);
}
function isDevBuild(releaseTag) {
    return ciSomethingPattern.test(releaseTag);
}
function findComparableTag(refTag, candidateTags) {
    return candidateTags.find((t) => areComparable(refTag, t));
}
function comparableReleaseTagToNumber(referenceReleaseTag, candidateTags) {
    const relatedTag = findComparableTag(referenceReleaseTag, candidateTags);
    if (!relatedTag) {
        return NaN;
    }
    return releaseTagToNumber(relatedTag);
}
function releaseTagToNumber(releaseTag) {
    const rSomethingResult = releaseTag.match(rSomethingPattern);
    if (rSomethingResult) {
        const parts = rSomethingResult
            .slice(1)
            .filter((v) => v)
            .map((v) => v.replace('-rc', ''));
        return numberFromParts(parts);
    }
    const ciSomethingResult = releaseTag.match(ciSomethingPattern);
    if (ciSomethingResult) {
        return numberFromParts(ciSomethingResult.slice(1));
    }
    throw new Error(`Could not convert ${releaseTag} to number`);
}
function numberFromParts(parts) {
    const maxParts = 4;
    if (parts.length > maxParts) {
        throw new Error(`Cannot get version int from ${parts.length} parts`);
    }
    let resultNumber = 0;
    let factor = Math.pow(10, 3 * maxParts);
    for (const n of parts) {
        resultNumber = resultNumber + factor * parseInt(n);
        factor = factor / 1000;
    }
    return resultNumber;
}
function isReleaseGreaterThanOrEqualToVersion(releaseVersion, version) {
    if (!version) {
        return false;
    }
    if (isReleaseBuild(version)) {
        const releaseNum = releaseTagToNumber(version);
        const introducedInReleaseNumber = releaseTagToNumber(releaseVersion);
        return releaseNum >= introducedInReleaseNumber;
    }
    return true;
}
//# sourceMappingURL=data:application/json;base64,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